
import { motion } from "framer-motion";
import heroImage from "../dosyalar/WhatsApp Image 2026-03-10 at 20.29.57 (1).jpeg";
import { Link } from "react-router-dom";

export default function AboutSection() {


  return (
    <section
      id="hakkimda"
      className="bg-white px-6 py-20 sm:py-28 lg:px-12 relative overflow-hidden"
    >
      <motion.div
        className="mx-auto max-w-6xl relative z-10 flex flex-col-reverse lg:flex-row items-center justify-between gap-12"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 0.7 }}
      >
        <div className="w-full max-w-2xl text-center lg:text-left space-y-6">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight">
    
            <span className="font-handwriting text-5xl">Aysun Şeremet</span>
          </h2>

          <div className="space-y-4 text-base sm:text-lg text-gray-700 leading-relaxed">
            Bireysel psikoterapi süreci, bilimsel yaklaşımlar ve etik ilkeler
            doğrultusunda yapılandırılmaktadır. Her danışan için güvenli ve
            gizliliğe önem veren bir terapötik alan oluşturulması esastır.
          </div>

          <Link
  to="/hakkimda"
  className="inline-flex items-center rounded-xl border border-gray-300 px-5 py-3 text-sm font-semibold text-gray-900 transition hover:bg-gray-50"
>
  Devamını Oku →
</Link>
        </div>

        <motion.div
          className="w-full lg:w-[36%] flex justify-center"
          initial={{ scale: 0.92, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: false, amount: 0.25 }}
          transition={{ duration: 0.7 }}
        >
          <div className="relative w-full max-w-sm overflow-hidden rounded-3xl shadow-2xl">
            <img
              src={heroImage}
              alt="Aysun Şeremet"
              className="h-[420px] w-full object-cover object-center sm:h-[500px]"
            />
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
}
